skrilla.controller('createdAudBankWithdrawalModalCtrl', function ($scope, cacheService, modalService, searchService) {
  $scope.account = cacheService.getObject("account");
  $scope.bankAccounts = cacheService.getObject("bankAccounts");
  $scope.active = $scope.bankAccounts.find(it => it.active);
  $scope.newAccount = {};

  $scope.newWithdrawal = {
    userId: $scope.account.ownerId,
    currency: $scope.account.currency,
    amount: 0,
    externalType: "AUD_BANK_ACCOUNT",
    bankAccount: null,
    bankAccountId: $scope.active ? $scope.active.id : null
  }
  $scope.create = function () {
    modalService.confirm("Are you'd like to create this withdrawal", function () {
      if ($scope.newWithdrawal.bankAccountId == null) {
        $scope.newWithdrawal.bankAccount = $scope.newAccount
      } else {
        $scope.newWithdrawal.bankAccount = null
      }
      const amount = Math.round($scope.newWithdrawal.amount * 100);
      const request = {...$scope.newWithdrawal, amount: amount }
      searchService.post("withdrawals", request, "Withdrawal successfully created").then(function (response) {
        modalService.dismissAll();
      });
    });
  }

});
